import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { SearchItemService } from '../../services/searchService'
import { ProductService } from '../../services/product.service'
import { CartService } from '../../services/cart.service'

import { FilterPipe } from './pipe'
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  dataText;
  title: String;
  names: any;
  itemProduct;
  constructor(private router: Router, private route: ActivatedRoute, private sear: SearchItemService, private product: ProductService, private cartService: CartService) {

  }
  ngOnInit() {
    this.route.url.subscribe(snap => {
      this.dataText = this.route.snapshot.params['dataName'];
      this.title = "ค้าหาสินค้า";
      let TemData = this.product.getProduct()
      TemData.subscribe(snap => {
        this.itemProduct = snap
      })

    })

  }

  addcart(i, id) {
    this.cartService.pushCart(id)
    //this.quantity = this.cartService.getCart()
    alert("เพิ่มสินค้าเข้า ตระกร้า")
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/search/search.component.ts